/**
 * WorkoutPrescriptionService
 * CRUD de prescrições de treino (modelo atrelado a aluno + período).
 * Coleção: tenants/{idTenant}/members/{idMember}/workoutPrescriptions
 *
 * Módulos internos:
 *   queries.js   — leituras de prescrições (getAll, getByMember, getActiveByMember, getActive)
 *   mutations.js — escritas de prescrições (prescribe, update, delete)
 *   sessions.js  — subcoleção de sessões (getAllSessionsByMember, getSessionsByPrescription, getNextPendingSession, completeSession)
 */
import { getAll, getByMember, getActiveByMember, getActive } from "./queries";
import { prescribe, update, deletePrescription } from "./mutations";
import { getAllSessionsByMember, getSessionsByPrescription, getNextPendingSession, completeSession } from "./sessions";

const WorkoutPrescriptionService = {
    getAll,
    getByMember,
    getActiveByMember,
    getActive,
    prescribe,
    update,
    delete: deletePrescription,
    getAllSessionsByMember,
    getSessionsByPrescription,
    getNextPendingSession,
    completeSession,
};

export default WorkoutPrescriptionService;
